import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { Router } from "@angular/router";
import { CommonService } from 'src/app/services/common.service';
import { MyAccountDto, MyaccountMobileOrEmailDto } from 'src/app/model/qModel.model';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { TranslateService } from '@ngx-translate/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';

declare let $: any;
@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
})
export class MyAccountComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild('fileInputModal') fileInputModal: ElementRef;

  returnWithEllipses: string;
  openGenderInputs: boolean = false;
  isLoading: boolean = true;
  recentImageUrl: string | null | SafeResourceUrl | SafeUrl | undefined;
  mobileInput: boolean = false;
  isProfileRemoved: boolean = false;
  resendotp: boolean = false;
  verifyEmail: boolean = false;
  verifyMobileNumber: boolean = false;
  enableEmailVerificationIcon: boolean = false;
  enableMobileVerificationIcon: boolean = false;
  otpValue: string = "";
  myaccountDto: MyAccountDto = new MyAccountDto();
  nameInputs: boolean = false;
  ageInputs: boolean = false;
  myAccountData: any;
  readyToUpload: boolean = false;
  fileToUpload: any;
  imageSrc: any;
  presignedUrl: any;
  selectedFiles: any;
  getObjecKey: any;
  s3Url: any;
  durationMinutes: any;
  timer: any;
  timeOver: boolean = true;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  isSentOTP: boolean = false;
  isSubmitted = false;
  isIncorrectOldpwdErr: any;
  isIncorrectOldpwd: boolean = false;
  PasswordNotMatch: any;
  PASSWORD_NOT_MATCH: any;
  pwdNotMatch: boolean = false;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  emailOrMobileVerificationDto: MyaccountMobileOrEmailDto = new MyaccountMobileOrEmailDto();
  verifyAccountForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    countryCode: new FormControl(''),
    userName: new FormControl(''),
    uploadImage: new FormControl(''),
    age: new FormControl(''),
    gender: new FormControl(''),
  });
  changePwdForm: FormGroup = new FormGroup({
    oldPassword: new FormControl(''),
    password: new FormControl(''),
    newPassword: new FormControl(''),
  });
  loggedInUser: any
  encrypt: any;

  formBuilder: any;
  social: any;

  fileUploadLoader: boolean = false;
  nameOfImage: string = '';
  sizeOfImage: string = '';
  base64textString: string = '';
  imageRequired: boolean = false;
  openCropper: boolean = false;
  imgUpload: boolean = false;
  isImage: boolean = false;
  croppedImage: any = '';
  imageChangedEvent: any = '';

  constructor(private router: Router, private _service: ApiService, private sanitizer: DomSanitizer, private _toastr: ToastrService, private _formBuilder: FormBuilder, private _httpClient: HttpClient,
    private translateService: TranslateService,
    private _commonservice: CommonService) {
    _commonservice.myAccount.subscribe((res: any) => {
      this.currentUserData.name = res.name;
      this.currentUserData.avatarUrl = res.avatarUrl;
    })
  }

  socialLogOutUrl: string = '';
  currentUserData: any;
  ngOnInit(): void {
    let social = localStorage.getItem('socialData');
    if (social) {
      this.social = JSON.parse(social);
      this.socialLogOutUrl = this.social.socialLogOutUrl
    }
    let logginUserStringValue = localStorage.getItem('currentUser');
    if (logginUserStringValue) {
      this.currentUserData = JSON.parse(logginUserStringValue);
    }
    this.verifyAccountForm = this._formBuilder.group(
      {
        name: [''],
        email: [''],
        countryCode: [''],
        userName: [''],
        uploadImage: [''],
        age: [''],
        gender: [''],

      },
    );
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);

    }
    setTimeout(() => {
      this.getMyAccountData();
    }, 0);
    this.nameInputs = false;
    this.ageInputs = false;
    this.openGenderInputs = false;
    this.presignedUrl = null;
    this.isLoading = false

    this.changePwdForm = this._formBuilder.group({
      oldPassword: ['', [
        RxwebValidators.password({
          validation: {
            upperCase: true,
            lowerCase: true,
            specialCharacter: true,
            digit: true
          },
        }),
        RxwebValidators.minLength({ value: 8 }),
        RxwebValidators.maxLength({ value: 50 }),
        Validators.required
      ],],
      password: ['', [RxwebValidators.password({
        validation: {
          upperCase: true,
          lowerCase: true,
          specialCharacter: true,
          digit: true
        }
      }), RxwebValidators.minLength({ value: 8 }),
      RxwebValidators.maxLength({ value: 30 })]],
      newPassword: ['', Validators.required],
    })

    const storedUser = localStorage.getItem('currentUser');
    this.currentUserData = storedUser ? JSON.parse(storedUser) : {};
  }
  //  TO Edit the name 
  openNameInput() {
    this.nameInputs = true;
  }
  //  TO Edit the age 
  openAgeInput() {
    this.ageInputs = true;
  }
  //  TO Edit the Gender 
  openGenderInput() {
    this.openGenderInputs = true;
  }
  //  TO verify Email or Mobile number here 
  emailResponse: any;
  otpPhoneError: any
  otpError: any
  verify(type: any) {
    this.isLoading = true
    this.otpPhoneError = null;
    let data;
    this.timeOver = true;
    clearInterval(this.timer);
    if (type == 'Send') {
      data = {
        countryCode: this.verifyAccountForm.controls['userName'].value?.dialCode,
        userName: this.verifyAccountForm.controls['userName'].value?.number
      }
    } else {
      this.otpPhoneError = null;
      this.ngOtpInputRef.setValue(null);
      data = {
        countryCode: this.verifyAccountForm.controls['userName'].value?.dialCode,
        userName: this.verifyAccountForm.controls['userName'].value?.number
      }
    }
    try {
      this._service.postService(this._service.API_URL.generateOTP, data).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          if (response.status.msgCode == "MOBILE_VERIFICATION") {
            this._toastr.success('', response.status.message);
            this.isLoading = false;
            this.isOtpVerification = true;
            this.enableMobileVerificationIcon = true;
            this.verifyMobileNumber = false;
            this.mobileInput = false;
            this.getMyAccountData();
          } else {
            this.startTimerForFiveMinute(3);
            this._toastr.success('', response.status.message);
            this.emailResponse = response.data;
            this.verifyEmail = true;
            this.verifyMobileNumber = true;
            this.isSentOTP = true;
            this.isLoading = false;
          }
        } else
          if (response.data == null || response.status.code === 400) {
            this.otpPhoneError = response.status.message;
            this.isLoading = false
          }
          else {
            this._toastr.error('', response.status.message);
            this.verifyEmail = false;
            this.verifyMobileNumber = false;
            this.isSentOTP = false;
            this.isLoading = false
          }
      })
    }
    catch (e) { }

  }

  resetvalues() {
    this.verifyEmail = false;
    this.verifyMobileNumber = false;
    this.isSentOTP = false;
    this.timeOver = true;
    this.durationMinutes = `01`
  }

  resendOTP() {
    this.resendotp = true
  }

  openMobileInput() {
    this.mobileInput = true;
  }
  onOtpChange(event: any) {
    this.otpPhoneError = null;
    this.otpError = null;
    this.otpValue = event;
  }

  //  Submitting the data here to verify Email or Mobile and Fetching the OTP;
  isOtpVerification: boolean = false;
  submitOTP(type: any) {
    this.otpError = null;
    this.otpPhoneError = null;
    try {
      if (type == 'EMAIL') {
        this.emailOrMobileVerificationDto.otpNo = this.otpValue,
          this.emailOrMobileVerificationDto.otpType = CommonEnums.EMAIL_VERIFICATION
      } else {
        this.emailOrMobileVerificationDto.otpNo = this.otpValue,
          this.emailOrMobileVerificationDto.otpType = CommonEnums.MOBILE_VERIFICATION,
          this.emailOrMobileVerificationDto.otpChar = this.emailResponse
      }
      if (this.otpValue?.length === 4) {
        this._service.postService(this._service.API_URL.otpVerification, this.emailOrMobileVerificationDto).subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isOtpVerification = true;
            this.verifyEmail = false;
            this.openGenderInputs = false;
            this.enableMobileVerificationIcon = true;
            this.verifyMobileNumber = false;
            this.timeOver = false;
            this.otpError = null;
            this.otpPhoneError = null;
            this.mobileInput = false;
            this.getMyAccountData();
            this._toastr.success('', response.status.message)
          } else if (response.data == null || response.status.code === 400) {
            this.otpError = response.status.message;
          }
          else {
            this.isOtpVerification = true;
            this.verifyEmail = false;
            this.openGenderInputs = false;
            this.enableMobileVerificationIcon = true;
            this.verifyMobileNumber = false;
            this.timeOver = false;
            this.mobileInput = false;
            this.getMyAccountData();
            this.otpError = response.status.meassage;

          }
        })
      }
    }
    catch (e) {

    }

  }
  InputKeyPress(e: any) {
    if (e.target.value == '' && e.which === 32) e.preventDefault();
  }

  //  Submitting the data here to update the my profile
  onSubmit() {
    this.isLoading = true
    try {
      this.isSubmitted = true;
      this.myaccountDto.name = this.verifyAccountForm.controls['name'].value;
      this.myaccountDto.age = this.verifyAccountForm.controls['age'].value;
      this.myaccountDto.gender = this.verifyAccountForm.controls['gender'].value;
      this.myaccountDto.avatarUrl = this.getObjecKey;
      this.myaccountDto.userName = this.verifyAccountForm.controls['userName'].value?.number;
      this.myaccountDto.countryCode = this.verifyAccountForm.controls['userName'].value?.dialCode;
      this._service.putService(this._service.API_URL.saveOrUpdateMyAccount, this.myaccountDto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this._toastr.success('', response.status.message);
          let currentUser = localStorage.getItem('currentUser');
          if (currentUser) {
            this.loggedInUser = JSON.parse(currentUser);
            this.loggedInUser.avatarUrl = this.myaccountDto.avatarUrl;
            this.loggedInUser.name = this.myaccountDto.name;
            localStorage.setItem('currentUser', JSON.stringify(this.loggedInUser));
          }
          this._commonservice.updateMyUserData(this.myaccountDto);
          this.verifyMobileNumber = false;
          this.isSentOTP = false;
          this.timeOver = false;
          this.mobileInput = false;

          this.isLoading = false

        } else {
          this._toastr.error('', response.status.message);
          this.isLoading = false
        }
      })
    } catch (error) {
      this.isLoading = false
    }
  }

  // Fetching the My Profile Data here 
  avatarImage: any;
  getMyAccountData() {
    this.isLoading = true
    try {
      this._service.getService(this._service.API_URL.getMyAccountData).subscribe((response) => {
        if (response && response.status.code === 200) {

          this.myAccountData = response.data;
          this._commonservice.updateMyUserData(response.data);

          setTimeout(() => {
            this.avatarImage = response.data.avatarUrl;
            this.isLoading = false
          }, 1000);
          this.getObjecKey = response.data.avatarUrl;
          this.verifyAccountForm.patchValue(response.data)
          this.nameInputs = false;
          this.ageInputs = false;
          this.openGenderInputs = false;
          console.table(this.myAccountData);
          this.returnWithEllipses = this.checkLength(this.myAccountData.name, this.myAccountData.lastName);
        }
      })
    } catch (error) {

    }
  }
  imageFileInoput: any


  handleFileInputImage(e: any) {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file size (max 5 MB)
    if (file.size > 5242880) {
      this._toastr.error(CommonEnums.MAX_UPLOAD_FILE);
      return;
    }

    this.nameOfImage = file.name;
    this.sizeOfImage = file.size;
    this.readyToUpload = true;
    this.isProfileRemoved = false;

    const reader = new FileReader();
    reader.onload = (event: any) => {
      // event.target.result already contains Base64 (data:image/png;base64,...)
      this.base64textString = event.target.result;
      this.recentImageUrl = event.target.result; // for preview
    };

    // Start reading the file as Base64
    reader.readAsDataURL(file);

    // Store file for upload
    this.selectedFiles = file;
  }



  uploadFile(file: File = this.selectedFiles) {
    if (!file) {
      this._toastr.error('', this.translateService.instant('TOSTRMSGS.QH_TOSTR_FILE_FIRST'));
      return;
    }

    this.fileUploadLoader = true;

    const obj = {
      size: file.size,
      fileName: file.name,
      contentType: file.type,
      base64String: this.base64textString
    };

    this._service.postService(this._service.API_URL.saveBase64Image, obj).subscribe({
      next: (response) => {
        if (response && response.status.code === 200) {
          this.imageRequired = false;
          this.openCropper = false;
          this.recentImageUrl = response.data;
          this.avatarImage = this.recentImageUrl;
          this.myAccountData.avatarUrl = this.recentImageUrl;
          this._commonservice.updateMyUserData(this.myAccountData);
          this.imgUpload = /\.(png|jpg|jpeg)$/i.test(this.recentImageUrl?.toString() || '');
          this.fileUploadLoader = false;
          this.toggleModalforImage(false);
          this.isImage = true;
          localStorage.setItem("recentImage", JSON.stringify(this.recentImageUrl));
          this._toastr.success(this.translateService.instant('TOSTRMSGS.QH_TOSTR_PROFILE_UPDATE'));
          console.log("avatarUrl after upload:", this.myAccountData?.avatarUrl);

        } else {
          this._toastr.error('', this.translateService.instant('TOSTRMSGS.QH_TOSTR_FILE_UPLOAD_FAILED'));
          this.fileUploadLoader = false;
        }
      },
      error: () => {
        this._toastr.error('', this.translateService.instant('TOSTRMSGS.QH_TOSTR_FILE_UPLOAD_FAILED_TRY_AGAIN'));
        this.fileUploadLoader = false;
      }
    });
  }


  resetCropper() {
    this.croppedImage = '';
    this.base64textString = ''
    this.imageChangedEvent = ''
    this.openCropper = false;
  }

  loadImageFailed(e?: any) {
    this.resetCropper();
    this._toastr.error('', this.translateService.instant('TOSTRMSGS.QH_TOSTR_FILE_CORRECT_FORMAT'));
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.base64textString = event.base64 ?? ''
  }


  removeProfile() {
    if (!this.myAccountData?.avatarUrl && !this.recentImageUrl) {
      this.translateService.instant('TOSTRMSGS.QH_TOSTR_NO_PROFILE_PICTURE')
      return;
    }

    $("#changeImageModal").modal("hide");
    $("#removeDevicePopup").modal("show");

    this.isProfileRemoved = false;
    this.fileToUpload = null;
    this.recentImageUrl = '';
  }


  deleteUploadedProfile() {
    this._service.deleteService(this._service.API_URL.deleteUploadedProfile).subscribe((response) => {
      if (response && response.status.code === 200) {
        this._toastr.success(this.translateService.instant('TOSTRMSGS.QH_TOSTR_PROFILE_REMOVE'));
        this.myAccountData.avatarUrl = null;
        this._commonservice.updateMyUserData(this.myAccountData);
        this.isProfileRemoved = true;
        this.recentImageUrl = '';
        this.getMyAccountData(); // refresh
      } else {
        this._toastr.error('', this.translateService.instant('TOSTRMSGS.QH_TOSTR_REMOVE_PROFILE_PICTURE'));

      }
    });
  }


  //  Start timer for Email Verification
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  // Checking on Mobie validation on Focus Out and Verifying
  mobileNoWrong: boolean = false;
  onFocusOutMobile(event: any) {
    if (this.verifyAccountForm.controls['userName'].value.number?.length < 8) {
      this.mobileNoWrong = true;
    } else {
      this.mobileNoWrong = false;
    }
    this.otpPhoneError = null;
  }
  get f(): { [key: string]: AbstractControl } {
    return this.verifyAccountForm.controls;
  }

  get p(): { [key: string]: AbstractControl } {
    return this.changePwdForm.controls;
  }
  removeSpace(event: any) {
    if (event.code === "Space") {
      event.preventDefault()

    }
  }

  // Open modal to change the profile image
  toggleModalforImage(val: boolean) {
    this.recentImageUrl = null;
    if (val) {
      $("#changeImageModal").modal("show");
      this.readyToUpload = false;
      this.presignedUrl = null;
      this.fileToUpload = null;
    }
    else {
      $("#changeImageModal").modal("hide");
    }
    this.fileInputModal.nativeElement.value = null;

  }


  logout() {
    this.isLoading = true;

    try {
      const sessionId = localStorage.getItem('sessionId');
      const jwtToken = localStorage.getItem('jwtToken');
      const refreshToken = this.currentUserData?.token?.refreshToken || null;

      const httpHeaders = new HttpHeaders({
        'SESSION-ID': sessionId || '',
        'Authorization': jwtToken || '',
        'Content-Type': 'application/json'
      });


      const data = { refreshToken: refreshToken };
      console.log('Logout headers:', {
        'SESSION-ID': sessionId,
        'Authorization': jwtToken
      });

      this._service.postService(this._service.API_URL.signOut, data, { headers: httpHeaders }).subscribe({
        next: (response: any) => {
          this.isLoading = false;

          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            this._commonservice.getSelectedLang.next('en');

            if (this.currentUserData?.isSocialLogin && this.socialLogOutUrl) {
              const back = window.open(this.socialLogOutUrl, "_blank");
              setTimeout(() => {
                back?.close();
                this.cleanupAndRedirect();
              }, 500);
            } else {
              this.cleanupAndRedirect();
            }

          } else {
            this._toastr.error('', response?.status?.message || 'Logout failed');
            this.cleanupAndRedirect();
          }
        },
        error: (error) => {
          console.error('Logout error:', error);
          this.isLoading = false;
          this.cleanupAndRedirect();
        }
      });
    } catch (error) {
      console.error('Logout exception:', error);
      this.isLoading = false;
      this.cleanupAndRedirect();
    }
  }

  private cleanupAndRedirect() {
    localStorage.clear();
    this.router.navigateByUrl('/');
  }


  openChangePassword() {
    this.changePwdForm.reset();
    $('#changePassword').modal('show');
    this.isIncorrectOldpwdErr = null;
    this.PasswordNotMatch = null;
  }
  goToMyAccount() {
    this.router.navigateByUrl('home/my-account')
  }
  changePassword() {
    try {
      this.isIncorrectOldpwdErr = null;
      this.PasswordNotMatch = null;
      let data = {
        "oldPassword": this.encrypt.encrypt(this.changePwdForm.controls['oldPassword'].value),
        "password": this.encrypt.encrypt(this.changePwdForm.controls['password'].value),
        "newPassword": this.encrypt.encrypt(this.changePwdForm.controls['newPassword'].value),
      }
      this._service.postService(this._service.API_URL.changeOrUpdatePassword, data).subscribe((response: any) => {

        if (response && response.status.code === 200) {
          this._toastr.success('', response.status.message);
          localStorage.clear();
          this.router.navigate(['/']);
          $('#changePassword').modal('hide');

          // this.isIncorrectOldpwd = false;
        }
        else {
          this.PASSWORD_NOT_MATCH = response.status.msgCode;
          if (this.PASSWORD_NOT_MATCH === "PASSWORD_NOT_MATCH") {
            this.PasswordNotMatch = response.status.message
          } else {
            this.isIncorrectOldpwdErr = response.status.message;
            this.PasswordNotMatch = null;

          }

          this.isIncorrectOldpwd = true;
        }

      })
    }
    catch (e) {
    }
  }
  onFocusOut() {
    if (this.changePwdForm.controls['password'].value !== this.changePwdForm.controls['newPassword'].value) {
      this.pwdNotMatch = true;
    }
    else {
      this.pwdNotMatch = false;
    }
  }

  oldPasswordNotMatch: boolean = false;
  checkOldPassword(envent: any) {
    if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['newPassword'].value) {
      this.oldPasswordNotMatch = true;
    } else {
      this.oldPasswordNotMatch = false
    }
  }

  passwordVerify(pwdType: any) {
    this.isIncorrectOldpwdErr = null;
    if (pwdType == 'new') {
      if (this.changePwdForm.controls['newPassword'].value?.length != 0 && this.changePwdForm.controls['password'].value !==
        this.changePwdForm.controls['newPassword'].value) {
        if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['password'].value && this.changePwdForm.controls['oldPassword'].value?.length > 2) {
          this.oldPasswordNotMatch = true;
          this.pwdNotMatch = false;

        }
        else {
          this.oldPasswordNotMatch = false;
          this.pwdNotMatch = true;

        }
      }
      else if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['password'].value && this.changePwdForm.controls['oldPassword'].value?.length > 2) {

        this.oldPasswordNotMatch = true;
        this.pwdNotMatch = false;

      }
      else {
        this.pwdNotMatch = false;
        this.oldPasswordNotMatch = false
      }
    }
    else {
      if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['password'].value && this.changePwdForm.controls['oldPassword'].value?.length > 2) {

        this.oldPasswordNotMatch = true;
        this.pwdNotMatch = false;

      }
      else {
        this.oldPasswordNotMatch = false;

      }
    }


  }

  closemodal() {
    this.isIncorrectOldpwdErr = null;
    this.PasswordNotMatch = null;
    this.pwdNotMatch = false;
    this.oldPasswordNotMatch = false;
    this.changePwdForm.reset();
    $('#changePassword').modal('hide');
    $('.modal-backdrop').remove();
    this.ngOnInit();
  }
  editMode: boolean = false;
  isupdateProfile: boolean = true;
  selectedIndex: number = 0;
  enableEdit(data: any) {
    if (data === 'editMode') {
      this.editMode = true;
    }
    else {
      this.editMode = false;
    }
  }
  disableEdit() {
    this.editMode = false;
    this.ngOnInit();
  }

  checkLength(firstName: string, lastName: string): string {
    console.log("check the values :" + firstName);
    const maxLength = 25;
    const appendDots = "...";
    let returnName = "";
    if (lastName != "" && lastName != undefined && lastName != null) {
      returnName = firstName + " " + lastName;
    } else {
      returnName = firstName;
    }
    if (returnName.length > 25) {
      return returnName.substring(0, maxLength) + appendDots;
    }
    return returnName;
  }

  genderMap: { [key: string]: string } = {
    'Male': 'MYACCOUNT.MALE',
    'Female': 'MYACCOUNT.FEMALE',
    'Other': 'MYACCOUNT.OTHER'
  };

  getGenderLabel(genderStr: string | null): string {
    if (!genderStr) return this.translateService.instant('MYACCOUNT.NA');
    const key = this.genderMap[genderStr];
    return key ? this.translateService.instant(key) : genderStr;
  }
}
